export const UI_COLORS = {
  PRIMARY: '#153052',
  SECONDARY: '#4D87C1',
  SUCCESS: '#22c55e',
  ERROR: '#ef4444',
  TEXT_MUTED: '#5A6C84',
  BG_SELECTED: '#e3f2fd',
  BG_HOVER: '#f5f5f5',
  BG_LIGHT: '#f0eded',
  BG_ACCENT: '#C6E3FF',
};

// Everything below holds auth state or per-user content and must not survive logout.
export const USER_DATA_STORAGE_KEYS = [
  'access_token', 'refresh_token', 'graph_token', 'token', 'token_expiry',
  'user', 'formData', 'sr_id', 'domains', 'alldomains',
  'policybot_messages', 'policybot_conversationId', 'policybot_expiredConversationId', 'policybot_home_question',
  'chatHistory', 'conversation_history', 'conversationHistory', 'conversationText', 'references',
  'question', 'askedQuestion', 'chatSource', 'responsePending', 'initialFetchDone', 'data-to-Submit',
  'editableTranscript', 'generatedAnswers', 'answerState', 'summary', 'transcript', 'it_id', 'FileName',
  'selectedAssociations', 'selectedYears', 'selectedMetrics',
];

export const CHAT_CONFIG = {
  MAX_QUERY_LENGTH: 2000,
  PROACTIVE_REFRESH_INTERVAL: 50 * 60 * 1000,
  TYPING_DELAY: 50,
};
